export function setValidity (vObj, options) {
  let valid = !vObj.errorBag.some(r => r.valid === false)
  if (options) {
    if (options.feedback) {
      // run the feeback div validity
      feedbackValidity(vObj, valid, options.feedback)
    }
    if (options.control) {
      // run control validity
      controlValidity(vObj, valid, options.control)
    }
  }
}

function feedbackValidity (vObj, valid, feedbackOpts) {
  let feedbackDiv = document.getElementsByName(vObj.compId)[0]
  if (!feedbackDiv) {
    
    return
  }
  removeFeedbackValidity(feedbackDiv)
  addFeedbackValidity(vObj, feedbackDiv, valid, feedbackOpts)
}
function removeFeedbackValidity (element) {
  element.innerText = ''
  if (element.classList.contains('valid-feedback')) {
    element.classList.remove('valid-feedback')
  }
  if (element.classList.contains('invalid-feedback')) {
    element.classList.remove('invalid-feedback')
  }
  if (element.classList.contains('d-block')) {
    element.classList.remove('d-block')
  }
}
function addFeedbackValidity (vObj, feedbackDiv, valid, feedbackOpts) {
  if (valid && feedbackOpts.valid) {
    feedbackDiv.classList.add('valid-feedback')
    feedbackDiv.innerText = feedbackDiv.attributes.validfeedback ? feedbackDiv.attributes.validfeedback.value : 'Looks Good!'
  } else if (!valid && feedbackOpts.invalid) {
    let invalidRules = vObj.errorBag.filter(r => r.valid === false)
    feedbackDiv.innerText = feedbackDiv.attributes.invalidfeedback ? feedbackDiv.attributes.invalidfeedback.value : invalidRules[0].feedback // get first rule
    feedbackDiv.classList.add('invalid-feedback')
  }
  feedbackDiv.classList.add('d-block')
}

function controlValidity (vObj, valid, controlOpts) {
  let controlElement = document.getElementById(vObj.compId)
  removeControlValidity(controlElement)
  addControlValidity(controlElement, valid, controlOpts)
}
function removeControlValidity (element) {
  if (element.classList.contains('is-valid')) {
    element.classList.remove('is-valid')
  }
  if (element.classList.contains('is-invalid')) {
    element.classList.remove('is-invalid')
  }
}
function addControlValidity (element, valid, controlOpts) {
  if (valid && controlOpts.valid) {
    element.classList.add('is-valid')
  } else if (!valid && controlOpts.invalid) {
    element.classList.add('is-invalid')
  }
}
